// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"08d278a3","40":"029c92b7","121":"0c0af326","263":"5d7cc164","564":"0b1af611","607":"f25683c1","719":"68810396"}[chunkId] + ".js";
};